import { render, staticRenderFns } from "./right_classify.vue?vue&type=template&id=7f7e22a6&scoped=true"
import script from "./right_classify.vue?vue&type=script&lang=js"
export * from "./right_classify.vue?vue&type=script&lang=js"
import style0 from "./right_classify.vue?vue&type=style&index=0&id=7f7e22a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7e22a6",
  null
  
)

export default component.exports